<script>
	import {
		cookiesActivated,
		customCss,
		customCssButtonTextOff,
		customCssButtonTextOn,
		history,
		pages,
		redirectToHome,
		useCustomCss
	} from '../share/stores';
	import { fetchUrl, writeLocalStorage } from '../share/utils';
	import CustomCssButton from '../components/CustomCssButton.svelte';
	import NavListElement from '../helpers/NavListElement.svelte';

	let paths = [];
	let breadcrumbs = [];

	async function findMatchingBreadCrumbs(html, searchPath) {
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = await html;
		//tempDiv is the most inner Link in Navigation which fits the URL
		const targetElement = tempDiv.querySelector(`a[href="${searchPath}"]`);
		paths = [];
		searchPath = redirectToHome.find(route => route.path === searchPath) ? '/' : searchPath;
		// not found in Grav /navigation and not home-URL:
		if(!targetElement && searchPath !== '/') {
			pushPath('/404', 'Upsi');
			pushPath('/', 'Home');
			return paths.reverse();
		}
		if (targetElement) {
			//we travel up the PageTree till there's no more Parent
			fromNavigation(targetElement);
		}
		else if (searchPath !== '/') {
			//if we can't find a fitting page in the tree we use the called URL
			fromUrl(searchPath);
		}
		pushPath('/', 'Home');
		return paths.reverse();
	}

	function fromNavigation(deepestElement) {
		let parent = deepestElement.parentElement;
		while (parent.parentElement) {
			const parentLink = parent.querySelector('a');
			if (parent.tagName.toLowerCase() == 'li' && parentLink) {
				pushPath(parentLink.getAttribute('href'), parentLink.innerText);
			}
			parent = parent.parentElement;
		}
	}

	function fromUrl(url) {
		let sanitizedPath = url.replace(/\W/g, '');
		sanitizedPath = sanitizedPath.charAt(0).toUpperCase() + sanitizedPath.slice(1);
		pushPath(url, sanitizedPath);
	}

	function pushPath(url, text) {
		if (Object.values(paths).some(path => path.url === url)) {
			return;
		}
		paths.push({
			url: url,
			text: text
		});
	}

	history.subscribe(async() => {
		breadcrumbs = await findMatchingBreadCrumbs(fetchUrl('/navigation'), location.pathname);
	});

	function toggleCustomCss() {
		useCustomCss.set(!$useCustomCss);
		if($cookiesActivated !== null) {
			writeLocalStorage({
				useCustomCss: $useCustomCss ? true : false
			});
		}
	}
</script>

<div class:multiplePages={$pages.length > 1}>
	<nav class="mobile">
		<ul>
			{#if breadcrumbs.length > 1}
				<NavListElement url={breadcrumbs[breadcrumbs.length - 2].url}
								text={breadcrumbs[breadcrumbs.length - 2].text.replace(/\_([^_]+)\_/, `<i>$1</i>`).replaceAll('_', ' ')}
				/>
			{/if}
		</ul>
	</nav>
	<nav class="desktop">
		<ul>
			{#each breadcrumbs as breadcrumb}
				<NavListElement url={breadcrumb.url}
								text={breadcrumb.text.replace(/\_([^_]+)\_/, `<i>$1</i>`).replaceAll('_', ' ')}
				/>
			{/each}
		</ul>
	</nav>

	<CustomCssButton
			buttonText={$customCssButtonTextOff && $customCssButtonTextOn ? (
						$useCustomCss ? $customCssButtonTextOn : $customCssButtonTextOff
				) : 'Kundenfarbwelt'}
			clickEvent={toggleCustomCss}
	/>
</div>

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";

	div {
		display: grid;
		transition: grid var(--animation-duration) linear, transform var(--animation-duration) linear;
		grid-template-columns: px-to-em(30) auto minmax(auto, var(--max-main-width)) auto px-to-em(30);
		background: black;
		padding: $spacing-mobile-one-third 0;
		
		@include for-tablet-landscape-up {
			grid-template-columns: px-to-rem(142) auto minmax(auto, var(--max-main-width)) auto px-to-rem(142);
			padding: $spacing-mobile*.25 0;
		}

		nav {
			grid-column-start: 2;
			grid-column-end: 4;

			@include for-phone-only {
				grid-column-end: 3;
			}

			&.mobile {
				display: none;

				@include for-phone-only {
					display: block;
				}

				:global(li a::before) {
					content: '';
					position: relative;
					margin-right: .5em;
					padding: 5px;
					height: 0px;
					display: inline-block;
					line-height: 0;
					border: solid #dedede;
					border-width: 0 3px 3px 0;
					transition: transform .2s ease-in-out;
					transform: rotate(135deg);
				}
			}
			&.desktop {
				display: block;

				@include for-phone-only {
					display: none;
				}

			}

			ul {
				list-style-type: none;
				display: flex;

				:global(li) {

					width: max-content;

					@include for-tablet-landscape-up {
						line-height: 3rem; /* affects the breadcrumb's height */
					}

					@include for-desktop-up {
						line-height: 1rem; /* affects the breadcrumb's height */
					}
				}

				:global(li div) {
					float: left;
				}

				:global(li a) {
					color: white;
					font-weight: normal;
					text-decoration: none;
					text-transform: uppercase;
				}

				:global(li a),
				:global(li::after) {
					font-size: 1.8rem;
					line-height: 2.2rem;
				}

				:global(li::after) {
					color: white;
					content: "//";
					margin: 0 .3em;
				}

				:global(li:last-of-type::after) {
					content: none;
				}

				:global(li:last-of-type a) {
					font-weight: 600;
				}
			}
		}
	}
</style>
